// // import BoatHero from 'assets/images/psp/hero/boat-hero.webp';
import GeorgeRansom from "assets/images/psp/review-george.png";
import AnnAlarcon from "assets/images/psp/review-ann.png";
import SMurphy from "assets/images/psp/review-murphy.png";
import WinterBoat from "assets/images/psp/relatedContentImages/winter-boat-jpg.webp"
import BoatWinter from "assets/images/psp/relatedContentImages/boat-winter.webp"
import StoreBoat from "assets/images/psp/relatedContentImages/store-boat.webp"
import Boat3 from "assets/images/psp/relatedContentImages/boat3.webp"
import HeaderBackgroundDesktop from "assets/images/psp/hero/boat-hero.webp";
import HeaderBackgroundMobile from "assets/images/psp/hero/boat-header-mobile.webp";
import HeaderBackgroundTablet from "assets/images/psp/hero/boat-header-tablet.webp";
import { storageCategories } from "../utils/getPSPLinks";

const reviews = {
	title: "Storage.com has a 4.4 out of 5 star rating on",
	testimonials: [
		{
			body: "The Storage.com representative was very helpful and made it easy for me to find a place to store my boat.",
			author: "Danny Smalls",
			title: "Boat Storage",
			imageSrc: SMurphy
		},
		{
			body: "The person from Storage.com who assisted me was super helpful and offered several options. I saved a lot of money because of the great deals your company could offer, which were below market rate if I had dealt directly with the storage company.",
			author: "Pasadena Garden Club",
			title: "The person who assisted me was super...",
			imageSrc: GeorgeRansom
		},
		{
			body: "Abby, the customer service representative at storage.com, was professional, helpful and friendly. She found me a storage space at an excellent price in close proximity to my home. I can't thank her enough.",
			author: "Ann Alarcon",
			title: "A wonderful experience",
			imageSrc: AnnAlarcon
		}
	]
};

const faqs = [
	{
		question: "What size storage unit do I need for my boat?",
		answer:
			"Measure your boat's total length including the trailer tongue and add 2-3 feet. Most boats under 18 feet fit in a 10x20 unit, while 20-25 foot boats need a 10x30. Always verify your boat storage box or unit dimensions with the facility before renting."
	},
	{
		question: "How do I prepare my boat for storage?",
		answer:
			"Clean thoroughly inside and out, drain all water systems, stabilize fuel or drain tanks, disconnect batteries, and remove valuables. For long-term storage, consider shrink-wrapping or using a quality cover to prevent moisture, pests, and dust damage."
	},
	{
		question: "Is indoor or outdoor storage better for boats?",
		answer:
			"Indoor storage provides superior protection from weather, UV rays, and theft, making it ideal for expensive boats or year-round storage. Outdoor covered storage offers a middle ground, while outdoor uncovered is the most budget-friendly—weigh the boat storage cost against your boat's value and storage duration."
	},
	{
		question: "Can I access my boat anytime at a storage facility?",
		answer:
			"Access policies vary by facility. Many boat & RV storage near me locations offer extended or 24-hour access, while others have gate hours. If you need frequent access for spontaneous outings, confirm access hours before renting."
	},
	{
		question: "Do I need insurance for my boat in storage?",
		answer:
			"Yes, most facilities require proof of insurance regardless of whether your boat is on the water or in storage. Boat insurance covers theft, damage, and liability—contact your insurance provider to confirm your policy covers storage situations and update your policy if needed."
	}
];

const boatSizeChartData = [
	{
		title: "10x20",
		bestFor: [
			"Boats up to 18 feet long",
			"Small boats",
			"Minimal gear & storage boxes"
		]
	},
	{
		title: "10x25",
		bestFor: [
			"Boats 18-22 feet long",
			"Small pontoons and bowriders",
			"Boat & trailer storage"
		]
	},
	{
		title: "10x30",
		bestFor: [
			"Boats 22-26 feet long",
			"Boat & trailer storage",
			"Accessory storage"
		]
	},
	{
		title: "10x35",
		bestFor: [
			"Boats 26-30 feet long",
			"Extended trailers"
		]
	},
	{
		title: "12x40+",
		bestFor: [
			"Boats 30-35 feet long",
			"Accessories",
			"Trailer storage"
		]
	}
];

const relatedContentCards = [
	{
		content:
			"The Ultimate Boat Storage Pricing Guide: Types, Pricing, & Tips",
		category: "Recreational Storage",
		date: "September 10, 2025",
		url: "https://www.storage.com/blog/boat-storage-costs-complete-guide/",
		image: StoreBoat
	},
	{
		content:
			"Short-Term and Long-Term Boat Storage Made Simple (Including Boat Winterization)",
		category: "Recreational Storage",
		date: "August 16, 2025",
		url: "https://www.storage.com/blog/boat-storage-guide/",
		image: Boat3
	},
	{
		content: "Where to Store Your Boat During Winter",
		category: "Self Storage",
		date: "March 12, 2025",
		url: "https://www.storage.com/blog/where-to-store-your-boat-during-winter/",
		image: BoatWinter
	},
	{
		content: "Winterization Guide: How to Protect and Store Your Boat",
		category: "Self Storage",
		date: "October 18, 2025",
		url: "https://www.storage.com/blog/winterize-your-boat-for-self-storage/",
		image: WinterBoat
	}
];

const boatHerodescription = `
Keep your boat and other recreational vehicles protected and ready for the next ride with secure storage close to home. Whether you need seasonal storage during winter months, lack [space for a trailer at home](https://www.storage.com/blog/truck-trailer-storage-guide/), or want protection from the elements year-round, there's a boat storage facility for you. From small fishing boats to large cabin cruisers, secure storage provides the weather protection and security that driveway parking can't offer, with options to fit every budget and boat size.
`

const boatStoragePricingOrdered = [
	{
		id: "1",
		value: `1. **Outdoor Uncovered**

   ***Average Monthly Cost:*** $50-$150

   ***Benefits:*** Budget option, ideal for short term boat storage`
	},
	{
		id: "2",
		value: `2. **Outdoor Covered**

   ***Average Monthly Cost:*** $100-$250

   ***Benefits:*** Seasonal protection for small and mid-sized boats`
	},
	{
		id: "3",
		value: `3. **Indoor Storage**

   ***Average Monthly Cost:*** $150-$400

   ***Benefits:*** Premium protection, great for year-round storage`
	},
	{
		id: "4",
		value: `4. **Climate Controlled Indoor Storage**

   ***Average Monthly Cost:*** $200-$500

   ***Benefits:*** Ideal for high-end boats with sensitive electronics`
	}
];

// ...existing code...
const boatPreparationRichContent = `
You can’t just pull your boat into storage and hope for the best. Here’s a quick guide on how to inspect, prepare, and store your boat all-year round.

**Cleaning and Inspection:**

1. Wash the entire boat thoroughly to remove salt, dirt, and debris
2. Dry completely, paying special attention to bilges and hidden areas to prevent mold
3. Apply a protective wax coating
4. Inspect the hull for cracks or blisters
5. Check the propeller for damage and remove tangled fishing line
6. Test electronics functionality
7. Remove valuables and gear if storing off-site

**Interior Preparation:**

1. Fill fuel tank and add fuel stabilizer
2. Drain all water from boat, engine, and lines
3. Flush engine with marine antifreeze
4. Check all fluids (drive oil, engine oil, gear oil) for water contamination
5. Winterize holding tanks, generators, and air conditioning systems
6. Keep air vents open for circulation
7. Place moisture absorbers in enclosed spaces
8. Vacuum carpets, clean surfaces and upholstery
9. Cover furniture and electronics once dry

**Exterior Preparation:**

1. Use a quality, weather-appropriate boat cover
2. Ensure proper drainage around storage location
3. Use tie-downs to anchor the boat
4. Store on gravel or paving stones to prevent sinking

**Ongoing Maintenance:**

1. Regularly inspect cover for tears
2. Set pest traps
3. Monitor for moisture or mold buildup
4. Disconnect and store battery on a wooden surface with a [trickle charger](https://www.storage.com/blog/what-is-battery-tender-vehicle-storage/)
5. Check battery periodically for corrosion
`

const boatStoragePreparation = `
**Indoor Boat Storage**
- Protection from weather, UV damage, and theft
- Ideal for long-term or winter storage
- Climate-controlled options prevent mildew and preserve interior components

**Covered Boat Storage**
- Carport-style covered spaces offer overhead protection from the elements
- Covered storage prevents the majority of weather damage and works well for boats that don't require a full enclosure

**Outdoor Boat Storage**
- Open-air parking provides the most budget-friendly option
- Boat storage box-style setup works for boaters who need short-term storage
`

export const PSPBoatContent = {
	type: "Boat",
	sections: [
		// ── 1. Hero Section ─────────────────────────
		{
			title: "Boat hero",
			noPadding: true,
			modules: [
				{
					type: "hero-section",
					props: {
						title: "Find the Top Boat Storage",
						description: boatHerodescription,
						searchPlaceholder: "Search by city, state, or zip...",
						buttonText: "Find Boat Storage",
						heroImages: {
							desktop: HeaderBackgroundDesktop,
							tablet: HeaderBackgroundTablet,
							mobile: HeaderBackgroundMobile
						},
						heroAltText: "Boat Storage Hero Image"
					}
				}
			]
		},

		// ── 2. Content Section - Boat Storage Types ─
		{
			title: "There's a Boat Storage Box or Storage Unit for Every Watercraft",
			noPadding: true,
			modules: [
				{
					type: "content-section",
					props: {
						title: "There's a Boat Storage Box or Storage Unit for Every Watercraft",
						description: "Boat storage facilities serve recreational boaters, anglers, and water sports enthusiasts who need secure space for their watercraft between outings. Whether you're looking for boat & RV storage near you to keep your toys together or need dedicated space for your vessel, storage facilities offer protection that extends your boat's life and maintains its value.",
						listType: "single",
						content: [
							{
								id: "1",
								value: boatStoragePreparation
							},
							{
								id: "2",
								value: "Many facilities catering to boat & RV storage offer [extra-wide drive aisles](https://www.storage.com/blog/drive-up-vs-first-floor-access-self-storage/) for trailer maneuvering, wash stations for pre-storage cleaning, and dump stations for gray water disposal."
							}
						],
						isColumnWise: false,
						background: "white"
					}
				}
			]
		},

		// ── 3. Size Chart ───────────────────────────
		{
			title: "What Storage Unit Size Do I Need for My Boat?",
			noPadding: true,
			modules: [
				{
					type: "size-chart",
					props: {
						pageType: "psp",
						background: "light-blue",
						title: "What Storage Unit Size Do I Need for My Boat?",
						description: "Use the boat storage size chart below to find the right-sized unit for your beloved vessel.",
						postModuleDescription: "*Always measure your boat's length from bow to stern, including the trailer tongue, plus add 2-3 feet for clearance.*",
						storages: boatSizeChartData
					}
				}
			]
		},

		// ── 4. Content Section ─────────────────────────
		{
			title: "How Much Does Boat Storage Cost?",
			noPadding: true,
			modules: [
				{
					type: "content-section",
					props: {
						title: "How Much Does Boat Storage Cost?",
						description: "Boat storage costs vary by location, storage type, boat size, and amenities. Based on current pricing data from Storage.com, here are the best deals you can find for the four most popular types of boat storage:",
						content: boatStoragePricingOrdered,
						isColumnWise: false,
						background: "white"
					}
				}
			]
		},

		// ── 5. Rich Content Section - Boat Prep ─────
		{
			title: "Is Your Boat Ready for Storage?",
			noPadding: true,
			modules: [
				{
					type: "video-content",
					props: {
						title: "Is Your Boat Ready for Storage?",
						description: "",
						additionalContent: true,
						markDown: boatPreparationRichContent,
						mediaType: "video",
						mediaUrl: "9KlqwyvTgSI",
						videoTitle: "Boat Storage Preparation Guide",
						textAlign: "left",
					}
				}
			]
		},

		// ── 6. Inline CTA ───────────────────────────
		{
			title: "Boat Storage CTA",
			noPadding: true,
			modules: [
				{
					type: "inline-cta",
					props: {
						storageType: "Boat"
					}
				}
			]
		},

		// ── 7. Reviews ──────────────────────────────
		{
			title: "Boat Storage Reviews",
			noPadding: true,
			modules: [
				{
					type: "reviews",
					props: reviews
				}
			]
		},

		// ── 8. FAQs ─────────────────────────────────
		{
			title: "Boat Storage FAQs",
			noPadding: true,
			modules: [
				{
					type: "faq",
					props: {
						title: "Boat Storage FAQs",
						faqs
					}
				}
			]
		},

		// ── 9. Related Content ──────────────────────
		{
			title: "Boat Storage Related Content",
			noPadding: true,
			modules: [
				{
					type: "related-content",
					props: {
						heading: "Learn More About Boat Storage",
						unitCards: relatedContentCards
					}
				}
			]
		},

		// ── 10. Link to Other PSPs ──────────────────
		{
			title: "Links to other PSP",
			noPadding: true,
			modules: [
				{
					type: "psp-links",
					props: {
						background: "white",
						storageGridContent: {
							title: "More Ways to Store",
							storageTypes: storageCategories.boat
						}
					}
				}
			]
		},

		// ── 11. Nearby Cities ───────────────────────
		{
			title: "Boat Storage Near You",
			noPadding: true,
			modules: [
				{
					type: "nearby-cities",
					props: {
						pageType: "PSP",
						background: "light-blue"
					}
				}
			]
		}
	]
};

export default PSPBoatContent;
